import React, { ReactElement } from 'react'
import { Flex, Image } from '@mindfulchefuk/design-system'

export type TRecipeModalImage = {
  imgAltText: string
  imgUrl: string
}

export const RecipeModalImage = ({
  imgAltText,
  imgUrl,
}: TRecipeModalImage): ReactElement => {
  return (
    <Flex
      mt={{ base: 0, sm: 16 }}
      mb={{ base: 16, sm: 0 }}
      ml={{ base: 0, sm: 24 }}
    >
      <Image src={imgUrl} alt={imgAltText} loading="eager" useFallback />
    </Flex>
  )
}
